import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
const firebaseConfig = {
  apiKey: "AIzaSyBsoan6JF2cLjhlmYKNpZO6E6Jf_bzKpnE",
  authDomain: "closing-cost-help.firebaseapp.com",
  databaseURL: "https://closing-cost-help.firebaseio.com",
  projectId: "closing-cost-help",
  storageBucket: "",
  messagingSenderId: "1053185146887",
  appId: "1:1053185146887:web:8d44372cef02132f"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
// export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();